type AnalyticsEvent = {
  event: string;
};

type ElementName = string;

type TrackedClickEventProps = AnalyticsEvent & {
  element_name: ElementName;
  lang: string;
};

function TrackedClickEvent<T extends ElementName>({
  element_name,
}: {
  element_name: T;
}): TrackedClickEventProps & { element_name: T } {
  return {
    element_name: element_name,
    event: "tracked_click",
    lang: "en",
  };
}

export { TrackedClickEvent };
